import store from '../../store/store';

export const shouldAllowAccess = (target: string):boolean => {
    const state: any = store.getState();
    const allowedRoles: any = state.user.PortalSettings.AllowedRoles;
    const userRoles: any = state.user.roles
    if(target === "none"){
        return true;
    }
    else if(!allowedRoles[target]){
        return false;
    }
    return allowedRoles[target].some((role: any) => userRoles.includes(role));
}